import domainPatterns from './domainPatterns.json'

export const BRICK_JOBS_BUNDLE_IDS = {
  android: {
    development: 'com.brickjobsemployee.development',
    staging: 'com.brickjobsemployee.staging',
    production: 'com.brickjobsemployee'
  },
  ios: {
    development: 'com.brickjobs.employee.development',
    staging: 'com.brickjobs.employee.staging',
    production: 'com.brickjobs.employee'
  }
}

export const VIVALDIS_BUNDLE_IDS = {
  android: {
    development: 'com.sealjobsvivaldisinterimemployee.development',
    staging: 'com.sealjobsvivaldisinterimemployee.staging',
    production: 'com.sealjobsvivaldisinterimemployee'
  },
  ios: {
    development: 'com.sealjobs.vivaldisinterimemployee.development',
    staging: 'com.sealjobs.vivaldisinterimemployee.staging',
    production: 'com.sealjobs.vivaldisinterimemployee'
  }
}

export const BRICKJOBS_DOMAIN_PATTERNS = domainPatterns.brickJobs

export const VIVALDIS_DOMAIN_PATTERNS = domainPatterns.vivaldis

export const APP_BRANDS = {
  BrickJobs: 'BrickJobs',
  VivaConnect: 'VivaConnect'
} as const

export type AppBrand = (typeof APP_BRANDS)[keyof typeof APP_BRANDS]

export const APP_BRAND_NAMES: Record<AppBrand, string> = {
  BrickJobs: 'BrickJobs',
  VivaConnect: 'VivaConnect'
}

export const APP_BRAND_SUPPORT_EMAILS: Record<AppBrand, string> = {
  BrickJobs: 'team@brickjobs.be',
  VivaConnect: 'team@vivaldispayroll.be'
}

export const APP_BRAND_SUPPORT_PHONES: Record<AppBrand, string> = {
  BrickJobs: '03 361 86 48',
  VivaConnect: '03 808 29 28'
}
